export var ECollectionBannerState;
(function (ECollectionBannerState) {
    ECollectionBannerState["AVAILABLE"] = "available";
    ECollectionBannerState["COMPLETED"] = "completed";
    ECollectionBannerState["EXPIRED"] = "expired";
    ECollectionBannerState["UPCOMING"] = "upcoming";
})(ECollectionBannerState || (ECollectionBannerState = {}));
export var EOwnedCollectionStatus;
(function (EOwnedCollectionStatus) {
    EOwnedCollectionStatus["IN_PROGRESS"] = "in_progress";
    EOwnedCollectionStatus["COMPLETED"] = "completed";
    EOwnedCollectionStatus["SUBMITTING"] = "submitting";
})(EOwnedCollectionStatus || (EOwnedCollectionStatus = {}));
export var EContentContentType;
(function (EContentContentType) {
    EContentContentType["markdown"] = "text/markdown";
    EContentContentType["plainText"] = "text/plain";
    EContentContentType["link"] = "link";
    EContentContentType["youtube"] = "youtube";
})(EContentContentType || (EContentContentType = {}));
export function noCardsDialogContentHasLootpackButton(content) {
    return content.buttonText !== undefined;
}
export function isFetched(collection) {
    return collection.numColumns !== undefined;
}
export function isProgressItemFetched(item) {
    return ((item === null || item === void 0 ? void 0 : item.collection) !== undefined);
}
export function hasUserData(ranking) {
    return (ranking === null || ranking === void 0 ? void 0 : ranking.rank) !== undefined;
}
export function fetchedSliceHasUserData(ranking) {
    return (ranking === null || ranking === void 0 ? void 0 : ranking.rank) !== undefined;
}
export function isRankingItemFetched(item) {
    return (item === null || item === void 0 ? void 0 : item.top) !== undefined;
}
